<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Güncel Alacak Yok"
      type="success"
      :closable="false"
      v-if="!Alacaklar && !lo">
    </el-alert>
    <el-table
      class="alttable table-xs"
      style="width: 100%"
      width="100%"
      :data="Alacaklar"
      v-if="Alacaklar && !lo"
      row-key="id"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      default-expand-all>
      <el-table-column
        prop="Adi"
        label="Kategori Adı"
      >
      </el-table-column>
      <el-table-column
        prop="Toplam"
        label="Toplam"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Tahsil"
        label="Tahsil"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Zam"
        label="Zam"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Kalan"
        label="Kalan"
        align="right"
        width="100">
      </el-table-column>
      <el-table-column
        prop="Guncel"
        label="Güncel"
        align="right"
        width="100">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      lo: true,
      Height: window.innerHeight - 270,
      Alacaklar: null,
      AltToplam: {
        Tahsil: 0,
        Guncel: 0,
        Kalan: 0,
        Zam: 0,
        Toplam: 0,
      }
    }
  },
  methods: {

    SayfaYukle() {
      this.lo = true;
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/alacak'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Alacaklar = response.Liste
            this.AltToplam = response.Bakiye
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam.Toplam;
      sums[2] = this.AltToplam.Tahsil;
      sums[3] = this.AltToplam.Zam;
      sums[4] = this.AltToplam.Kalan;
      sums[5] = this.AltToplam.Guncel;
      return sums;
    },
  },
  created() {
    this.SayfaYukle();
    if (this.Bina_id === 'Sirket') this.Height = window.innerHeight - 231;
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/Alacak.vue